import script from "./BowlerProfileView.vue?vue&type=script&lang=ts&setup=true"
export * from "./BowlerProfileView.vue?vue&type=script&lang=ts&setup=true"

import "./BowlerProfileView.vue?vue&type=style&index=0&id=1c520304&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c520304"]])

export default __exports__